import moment from 'moment'
import { SkudAuditEndpoint } from '@/views/skud/shared/endpoint_services/skud-audit-endpoint-service'
import { envelopeError } from '@/views/skud/shared/modules/skud-http'
import { AuditAction, enumText } from '@/views/skud/shared/models/enums'

const DATE_FMT = 'DD.MM.YYYY HH:mm:ss'

function fmt (v) {
  return v ? moment(v).format(DATE_FMT) : null
}

export function auditActionColor (action) {
  switch (Number(action)) {
    case 0: return 'green'
    case 1: return 'orange'
    case 2: return 'red'
    default: return 'grey'
  }
}

export class SkudAuditService {
  constructor () {
    this.endpoint = new SkudAuditEndpoint()
    this.error = null
  }

  // filters: from,to,entity_table,actor,entity_id,action,limit (def 100).
  async getAudit (placeId, filters) {
    const params = Object.assign({ limit: 100 }, filters)
    // Дата «по» из фильтра — без времени, включаем весь день.
    if (params.to && params.to.length === 10) params.to += 'T23:59:59'
    const res = await this.endpoint.getAudit(placeId, params)
    if (!res) {
      this.error = envelopeError(this.endpoint.lastError)
      return { items: [] }
    }
    this.error = null
    const items = (res.items || []).map(x => ({
      id: x.id,
      occurred_at: fmt(x.occurred_at),
      actor: x.actor,
      action: x.action,
      action_text: enumText(AuditAction, x.action),
      action_color: auditActionColor(x.action),
      entity_table: x.entity_table,
      entity_id: x.entity_id,
      place_id: x.place_id,
      place_name: x.place_name,
      old_values: x.old_values,
      new_values: x.new_values
    }))
    return { items: items }
  }
}
